/**
 * Static real-estate browse catalogue (Phase B.5B).
 *
 * There is no property CMS / catalogue API yet.
 * These entries are display configuration only — requests persist through
 * /investors/real-estate APIs using property_id / property_name / location.
 * Availability figures are indicative, not operational inventory truth.
 *
 * Future: Property Management APIs should replace this file.
 */

export const REAL_ESTATE_CATALOGUE_NOTE =
  "Property listings are illustrative. Availability and pricing are confirmed by staff after you submit a request.";

export const REAL_ESTATE_PROPERTIES = [
  {
    id: "iwo-estate",
    name: "Iwo Estate — Plot Units",
    location: "Iwo, Osun State",
    landType: "Residential land",
    pricePerUnitNgn: 1200000,
    unitLabel: "plot",
    availableUnitsLabel: "Limited plots",
    documentation: "Registered Deed of Assignment, Survey Plan",
    inspectionHint: "Weekly guided site tours (Saturdays)",
    shortDescription:
      "Affordable residential plots in a developing community with planned road network and security.",
    fullDescription:
      "Iwo Estate offers titled residential plots in a growing community close to schools, markets, and main road access. Plots are demarcated, surveyed, and ready for development.",
    helpsWith: [
      "Site visits and guided inspections",
      "Documentation collection and verification",
      "Payment plan structuring",
      "Handover and beacon placement",
    ],
  },
  {
    id: "ibadan-corridor",
    name: "Ibadan Growth Corridor",
    location: "Ibadan, Oyo State",
    landType: "Mixed-use land",
    pricePerUnitNgn: 2500000,
    unitLabel: "plot",
    availableUnitsLabel: "Limited plots",
    documentation: "Governor's Consent in view, Survey Plan",
    inspectionHint: "On-site and virtual walkthroughs available",
    shortDescription:
      "Strategically located plots along an expanding commercial corridor — ideal for long-term value.",
    fullDescription:
      "Sited within Ibadan's expanding commercial corridor with strong appreciation potential. Suitable for residential, light commercial, or hold-for-appreciation strategies.",
    helpsWith: [
      "Title and search verification",
      "Coordination with surveyors and lawyers",
      "Inspection scheduling",
      "Investment advisory on resale",
    ],
  },
  {
    id: "epe-coastal",
    name: "Epe Coastal Land Bank",
    location: "Epe, Lagos State",
    landType: "Land banking",
    pricePerUnitNgn: 3800000,
    unitLabel: "plot",
    availableUnitsLabel: "Limited plots",
    documentation: "Excision in progress, Deed of Assignment",
    inspectionHint: "Monthly inspection convoy from Lagos",
    shortDescription:
      "Coastal-belt land bank in fast-developing Epe — designed for medium-term capital appreciation.",
    fullDescription:
      "A curated land bank in the Epe coastal belt, an area benefiting from major infrastructure projects. Suitable for buyers who want to lock in current pricing and resell or develop over 2–5 years.",
    helpsWith: [
      "Group inspection logistics",
      "Excision and title tracking updates",
      "Resale and exit guidance",
      "Documentation issuance",
    ],
  },
  {
    id: "lekki-phase-plot",
    name: "Lekki Residential Plots",
    location: "Lekki Phase 2, Lagos State",
    landType: "Residential land",
    pricePerUnitNgn: 15000000,
    unitLabel: "plot",
    availableUnitsLabel: "By enquiry",
    documentation: "Certificate of Occupancy / Deed of Assignment (as applicable)",
    inspectionHint: "Weekend and weekday inspections by appointment",
    shortDescription:
      "Prime residential plots with strong demand — request an inspection to confirm details.",
    fullDescription:
      "Select residential plots in Lekki Phase 2. Exact plot allocation, title status, and pricing are confirmed during staff follow-up and inspection.",
    helpsWith: [
      "Inspection scheduling",
      "Documentation review",
      "Allocation follow-up",
      "Next-step advisory",
    ],
  },
];

export function getRealEstatePropertyById(id) {
  return REAL_ESTATE_PROPERTIES.find((p) => p.id === id) || null;
}
